'use client'

import { cn } from '@mntn-dev/ui-utilities'

export type DividerProps = {
  className?: string
  orientation?: 'horizontal' | 'vertical'
}

export const Divider = ({
  className,
  orientation = 'horizontal',
}: DividerProps) => {
  return orientation === 'horizontal' ? (
    <div className={cn('w-full h-px', className)}>
      <svg
        height="1"
        width="100%"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 100 1"
        preserveAspectRatio="none"
        fill="none"
      >
        <g opacity="0.5">
          <rect
            width="100%"
            height="1"
            fill="url(#qf-gradient-divider-horizontal)"
          />
        </g>
        <defs>
          <radialGradient
            id="qf-gradient-divider-horizontal"
            cx="50%"
            cy="50%"
            r="50%"
            fx="50%"
            fy="50%"
          >
            <stop offset="0%" stopColor="#9CABB9" stopOpacity="0.7" />
            <stop offset="80%" stopColor="#9CABB9" stopOpacity="0.25" />
            <stop offset="100%" stopColor="#9CABB9" stopOpacity="0" />
          </radialGradient>
        </defs>
      </svg>
    </div>
  ) : (
    <div className={cn('w-px h-full bgg-fade-out opacity-50', className)} />
  )
}
